import { NgModule, Optional, SkipSelf } from '@angular/core';

import { SettingsService } from './settings/settings.service';
import { ThemesService } from './themes/themes.service';
import { TranslatorService } from './translator/translator.service';
import { MenuService } from './menu/menu.service';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { SessionService } from './core/session.service';
import { RestService } from './core/rest.service';
import { JwtHttp } from './core/JwtHttp';
import { CommonModule } from '@angular/common';
import { TreelistEventService } from './shared/treelist/treelist-event.service';
import { TreelistRest } from './shared/treelist/treelist.rest';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PermissionsService } from './services/permissions/permissions.service';
import { GridParamsRestoringService } from './services/grid-params-restoring/grid-params-restoring.service';
import { RoutingHistoryService } from './services/routing-history/routing-history.service';
import { SpinnerService } from './services/spinner-handler/spinner-handler.service';
import { PrintoutService } from './services/printout/printout-service.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        SettingsService,
        ThemesService,
        TranslatorService,
        MenuService,
        SessionService,
        RestService,
        JwtHttp,
        TreelistEventService,
        TreelistRest,
        PermissionsService,
        RoutingHistoryService,
        GridParamsRestoringService,
        SpinnerService,
        PrintoutService
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
